import React from 'react'
import { useHref, useLinkClickHandler } from 'react-router-dom'

import { BaseLinkProps } from './BaseLink.types'

/**
 * The BaseLink component is the replacement for the react-router-dom Link
 * component. It is used to link users to other pages within the app.
 *
 * @param {boolean} replace - Whether or not to replace the current history
 *   entry instead of adding a new one.
 * @param {any} state - The state to pass to the new page.
 * @param {function} onClick - Function fired on click of the link
 * @param {string} to - URL the user should be sent to
 * @param {string} target - Whether a link should open in a new window or not
 * @returns {React.ReactNode} - A link component
 */

export const BaseLink = React.forwardRef(
  (
    { onClick, replace = false, state, target, to, ...rest }: BaseLinkProps,
    ref: React.Ref<HTMLAnchorElement>,
  ) => {
    let href = useHref(to)
    let handleClick = useLinkClickHandler(to, {
      replace,
      state,
      target,
    })

    return (
      <a
        {...rest}
        href={href}
        onClick={event => {
          onClick?.(event)
          if (!event.defaultPrevented) {
            handleClick(event)
          }
        }}
        ref={ref}
        target={target}
      />
    )
  },
)
